import React from 'react';

import { Container } from './styles';

const ButtonCancel = ({ children, icon: Icon, ...rest }) => {
  return (
    <Container>
      <button type="button" {...rest}>
        {Icon && <Icon size={16} />}
        {children}
      </button>
    </Container>
  );
};

export default ButtonCancel;
